"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var i0 = require("@angular/core");
var ActionService = /** @class */ (function () {
    function ActionService() {
        this.sideNavDisplay = new rxjs_1.Subject();
    }
    /**
     * Use to change sidenav display
     * @data type: string
     */
    ActionService.prototype.sideNavDisplayChange = function (data) {
        this.sideNavDisplay.next(data);
    };
    ActionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ActionService_Factory() { return new ActionService(); }, token: ActionService, providedIn: "root" });
    return ActionService;
}());
exports.ActionService = ActionService;
